import moment from "moment";
import { ObjectType } from "typescript";
import WebService from "./WebService";
import { toast } from "react-toastify";
const HelperService = {
  getFormattedDateForDetail(dt: any, format?: any) {
    var stillUtc = moment.utc(dt).toDate();
    if (dt) {
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc)
          .local()
          .format(
            (localStorage.getItem("date_format") ?? "DD-MM-YYYY") + " hh:mm A"
          );
      }
    }
  },
  allowOnlyNumericValue(e: any, maxlength?: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (maxlength > 0) {
      if (e.key != "Backspace" && e.target.value.length >= maxlength) {
        e.preventDefault();
        return false;
      }
    }
  },
  allowOnlyAlphabeticValue(e: any, maxlength?: number) {
  const letters = /^[a-zA-Z]$/;

  // allow backspace
  if (!e.key.match(letters) && e.keyCode !== 8) {
    e.preventDefault();
    return false;
  }

  // max length check
  if (maxlength && maxlength > 0) {
    if (e.key !== "Backspace" && e.target.value.length >= maxlength) {
      e.preventDefault();
      return false;
    }
  }
},
  generateUUID() {
    return crypto.randomUUID();
  },
  getFormatedDate(d: any) {
    return d ? moment.utc(d).format("MM/DD/YY") : "";
  },

  getTitleCase(value: any) {
    if (!value) {
      return "";
    } else {
      var str = "";
      var arr = value.split("_");
      for (var i in arr) {
        if (Number(i) == 0) {
          str =
            arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
        } else {
          str +=
            " " +
            arr[i].charAt(0).toUpperCase() +
            arr[i].substring(1).toLowerCase();
        }
      }
      return str;
    }
  },
  getStatusTags(status: any) {
    if (!status) return "";

    // Convert "PENDING_CONFIRMATION" → "Pending Confirmation"
    const formatted = HelperService.getTitleCase(
      status.replace(/_/g, " ")
    ).trim();

    let className = "badge "; // base class

    // BACKGROUND COLOR LOGIC
    switch (status) {
      case "PENDING_CONFIRMATION":
      case "PENDING":
        className += "bg-warning text-dark";
        break;

      case "CONFIRMED":
      case "PASSED":
        className += "bg-success";
        break;
      case "PAID":
      case "PAID":
        className += "bg-success";
        break;
      case "PENDING":
      case "PENDING":
        className += "bg-warning text-dark";
        break;

      case "FAILED":
      case "REJECTED":
        className += "bg-danger";
        break;

      default:
        className += "bg-secondary";
    }

    return (
      <span className={className} style={{ fontSize: "12px" }}>
        {formatted}
      </span>
    );
  },

  getStatusTag(status: any) {
    if (!status) return "";

    const formattedStatus = HelperService.getTitleCase(status).toLowerCase(); // lowercase for logic
    let color = "gray";

    if (formattedStatus === "active") color = "green";
    else if (formattedStatus === "inactive") color = "red";

    return (
      <span style={{ color, fontWeight: 600 }}>
        {HelperService.getTitleCase(formattedStatus)}
      </span>
    );
  },

  numberWithCommas(value: string | number): string {
    if (value === null || value === undefined) return "0";
    const str = value.toString();
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  formatDuration(time: any) {
    if (!time) return "—";
    const [hours, minutes] = time.split(":").map(Number);

    const hourText =
      hours > 0
        ? `${hours.toString().padStart(2, "0")} hour${hours > 1 ? "s" : ""}`
        : "";
    const minuteText =
      minutes > 0 ? `${minutes.toString().padStart(2, "0")} min` : "";

    return (
      `${hourText}${hourText && minuteText ? " " : ""}${minuteText}` || "—"
    );
  },

  getTitleCaseWithSpace(value: any) {
    if (!value) {
      return "";
    } else {
      var str = "";
      var arr = value.split("_");
      for (var i in arr) {
        if (Number(i) == 0) {
          str =
            arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
        } else {
          str +=
            " " +
            arr[i].charAt(0).toUpperCase() +
            arr[i].substring(1).toLowerCase();
        }
      }
      return str;
    }
  },

  filenameFromContentDisposition(cd?: string | null): string | null {
    if (!cd) return null;

    // filename*=UTF-8''my%20file.pdf
    const star = /filename\*\s*=\s*[^']*''([^;]+)/i.exec(cd);
    if (star?.[1]) {
      try {
        return decodeURIComponent(star[1]);
      } catch {}
    }

    // filename="my file.pdf"
    const quoted = /filename\s*=\s*"([^"]+)"/i.exec(cd);
    if (quoted?.[1]) return quoted[1];

    // filename=myfile.pdf
    const plain = /filename\s*=\s*([^;]+)/i.exec(cd);
    if (plain?.[1]) return plain[1].trim();

    return null;
  },
};

export default HelperService;
